/**
 * Constantes do projeto.
 */

/**
 * Módulos da aplicação.
 */
export const MODULES = {
  CW: 'CapturaWeb',
  PUSH: 'Push',
  DT: 'DataTeam',
  REPORTS: 'Relatórios',
} as const;

/**
 * Status de requisições.
 */
export const REQUEST_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  LOADING: 'loading',
} as const;

/**
 * Cores para status.
 */
export const STATUS_COLORS: Record<string, string> = {
  pending: 'default',
  processing: 'processing',
  success: 'success',
  error: 'error',
  warning: 'warning',
  loading: 'processing',
};

/**
 * Labels para status.
 */
export const STATUS_LABELS: Record<string, string> = {
  pending: 'Pendente',
  processing: 'Processando',
  success: 'Sucesso',
  error: 'Erro',
  warning: 'Aviso',
  loading: 'Carregando',
};

/**
 * Tempo de atualização de requisições (em milissegundos).
 */
export const REQUEST_UPDATE_INTERVAL = 10000; // 10 segundos

/**
 * Tempo de atualização em segundos (para exibição).
 */
export const REQUEST_UPDATE_SECONDS = 10;

